import { useMutation } from '@tanstack/react-query';

import { ReportsControllerGetBookingReportExcelV1Params, getSMPBackendAPIAdmin } from '@/proxy';

function getDashboardExport(params: ReportsControllerGetBookingReportExcelV1Params) {
  return getSMPBackendAPIAdmin().reportsControllerGetBookingReportExcelV1(params);
}

export function useDashboardExport() {
  return useMutation({ mutationFn: getDashboardExport });
}
